import { z } from "zod";

export const warehouseSchema = z.object({
  id: z.number(),
  name: z.string(),
  code: z
    .string()
    .max(2, "crud.warehouses.validate.max_length")
    .regex(/^[a-zA-Z0-9]*$/, "crud.warehouses.validate.alphanumeric"),
  status: z.boolean(),
  calloff_rule: z.enum(["normal", "sleep_set"]),
});

export type WarehouseModel = z.infer<typeof warehouseCreateSchema>;

export const warehouseCreateSchema = z.object({
  id: z.number(),
  name: z.string(),
  code: z
    .string()
    .max(2, "crud.warehouses.validate.max_length")
    .regex(/^[a-zA-Z0-9]*$/, "crud.warehouses.validate.alphanumeric"),
  status: z.boolean().default(true),
  calloff_rule: z.enum(["normal", "sleep_set"]),
  number_of_paths: z.number(),
  number_of_positions: z.number(),
  height: z.number(),
});
